module.exports = __webpack_public_path__ + "./images/5321a36b739e2acffc3dc72315edd5e1.webp";